// @ts-strict-ignore
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { UserContext } from '~/dashboard/context';
import type { WorkflowState } from '../store/redux/state';
import apiCalls from '~/helpers/apiCalls';
import type { ResponseException } from '~/helpers/exceptionHandler';

type UseWorkflowLockingOptions = {
  workflowToken: string;
};

function getQueryKey({ workflowToken }: UseWorkflowLockingOptions) {
  return ['workflow.locking', workflowToken];
}

function useWorkflowLocking(options: UseWorkflowLockingOptions) {
  const {
    typhonDomain,
    featureFlags,
    agent,
  } = useContext(UserContext);

  const isWorkflowLockingEnabled = featureFlags?.workflowLocking;

  const { workflowToken } = options;
  return useQuery<WorkflowState['locking'], ResponseException>({
    queryKey: getQueryKey(options),
    queryFn: async () => {
      const workflowLockingState = {
        isLocked: false,
        isLoggedInAgentOwner: false,
        ownerEmail: null,
        ownerFirstName: null,
        ownerLastName: null,
      };
      if (isWorkflowLockingEnabled) {
        const workflowCheckout = await apiCalls.workflows.getWorkflowCheckoutInfo({
          appToken: workflowToken,
          typhonDomain,
        });
        const isLocked = workflowCheckout.checked_out;
        if (isLocked) {
          const owner = workflowCheckout.checkout_agent;
          workflowLockingState.isLocked = true;
          workflowLockingState.isLoggedInAgentOwner = owner.agent_email === agent.email;
          workflowLockingState.ownerEmail = owner.agent_email;
          workflowLockingState.ownerFirstName = owner.agent_first_name;
          workflowLockingState.ownerLastName = owner.agent_last_name;
        }
      }
      return workflowLockingState;
    },
    retry: false,
    refetchOnReconnect: false,
  });
}

useWorkflowLocking.getQueryKey = getQueryKey;
export default useWorkflowLocking;
